import {
  EDIT_KNOW_WAY,
  FETCH_KNOW_WAY,
} from './KnowWayActions'

const INITIAL_STATE = {
  items: [],
  meta: {},
  filters: [],
  editingknowWay: null,
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_KNOW_WAY.SUCCESS:
      return {
        ...state,
        items: action.payload.data,
        meta: action.payload.meta,
      }
    case EDIT_KNOW_WAY.SUCCESS:
      return {
        ...state,
        editingknowWay: action.payload,
      }
    default:
      return state
  }
}

export const getKnowWayListData = state => {
  return {
     items: state.knowWay.items,
  }
}

export const getEditingServiceCat = state => {
  return state.knowWay.editingknowWay
}
